import { ReactNode } from "react";
import { ModuleId } from "@cerberus/modules";
import { useModuleEnabled } from "@/modules/ModulesProvider";
import PageNotFound from "../PageNotFound";

/**
 * Gates a route on an enabled module. The route tree used to omit these paths entirely when the
 * module was off (a TeleHeadache-only page in CL mode), so a direct URL fell through to
 * PageNotFound. The tree is static now, so the route exists and this reproduces that outcome.
 */
const RequireModule = ({
  id,
  children,
}: {
  id: ModuleId;
  children: ReactNode;
}) => (useModuleEnabled(id) ? children : <PageNotFound />);

export default RequireModule;
